import { Component, OnInit } from '@angular/core';
import { DeviceUtility } from '../../shared/utilities/device.utility';
import { User } from '../../shared/models/user.model';

import { SessionService } from '../../shared/services/session.service';

declare var jQuery: any;

@Component({
  selector: 'office-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  saludo: string;

  images: any[];

  user: User;

  constructor(
    private _sessionService: SessionService
  ) {

    this.showName();
    this._sessionService.changeContractObservable.asObservable().subscribe(
      value => {
        if (value) {
          this.showName();
        }

      }
    )
  }

  private showName(): void {
    this.user = this._sessionService.getCurrentUser();
  }

  ngOnInit() {
    jQuery('.slider').slick({
      dots: true,
      infinite: true,
      speed: 300,
      autoplay: true,
      autoplaySpeed: 10000,
      //centerMode: true,
      //variableWidth: true,
      //adaptiveHeight: true,
    });
  }


}



// WEBPACK FOOTER //
// /app/src/app/office/home/home.component.ts